import memoize from 'lodash.memoize';

function createDateFormatter(locale, options) {
    return new Intl.DateTimeFormat(locale, options);
}

function resolve(locale, options) {
    return `${locale}/${JSON.stringify(options)}`;
}

export default memoize(createDateFormatter, resolve);
